<template>
	<multiselect
			:value="value"
			:placeholder="placeholder"
			:noOptions="noOptions"
			:options="optionItems"
			:multiple="multiple"
			:taggable="taggable"
			:loading="isLoading"
			:internal-search="vueSelectInternalSearch"
			:label="vueSelectLabel"
			:track-by="vueSelectTrackBy"
			:clear-on-select="vueSelectClearOnSelect"
			:close-on-select="vueSelectCloseOnSelect"
			:hide-selected="vueSelectHideSelected"
			:allow-empty="vueSelectAllowEmpty"
			:reset-after="vueSelectResetAfter"
			@search-change="searchChange"
			@input="onInputHandler"
			@select="onSelectHandler"
			@remove="onRemoveHandler"
	>
		<template slot="vueSelectLabel" slot-scope="{ option }">{{ option.name }}</template>
		<span slot="noOptions" slot-scope="{ search }">{{ search ? noOptions : noOptionsEmptySearch }}</span>
		<span slot="noResult">{{ noResult }}</span>
	</multiselect>
</template>

<script>
  import { baseInput } from './../mixins/index.js';
  import Multiselect   from 'vue-multiselect';
  import 'vue-multiselect/dist/vue-multiselect.min.css';

  export default {
    name: 'Autocomplete',
    mixins: [baseInput],
    props: {
      asyncFind: { type: Function, required: false },
      options: { type: Array, required: false, default: () => [] },
      multiple: { type: Boolean, required: false, default: true },
      taggable: { type: Boolean, required: false, default: false },
      noOptions: { type: String, required: false, default: 'Empty' },
      noOptionsEmptySearch: { type: String, required: false, default: 'Start typing' },
      noResult: { type: String, required: false, default: 'No elements found' },
      vueSelectLabel: { type: String, required: false, default: 'name' },
      vueSelectTrackBy: { type: String, required: false, default: 'id' },
      vueSelectClearOnSelect: { type: Boolean, required: false, default: true },
      vueSelectCloseOnSelect: { type: Boolean, required: false, default: true },
      vueSelectHideSelected: { type: Boolean, required: false, default: false },
      vueSelectAllowEmpty: { type: Boolean, required: false, default: true },
      vueSelectResetAfter: { type: Boolean, required: false, default: false },
      vueSelectInternalSearch: { type: Boolean, required: false, default: false }
    },
    data() {
      return {
        inputValue: null,
        hasFocus: false,
        isLoading: false,
        asyncOptions: []
      };
    },
    computed: {
      optionItems() {
        return this.asyncFind ? this.asyncOptions : this.options;
      }
    },
    methods: {
      onInputHandler(value, id) {
        this.$emit('input', value, id);
      },
      onSelectHandler(selectedOption, id) {
        this.$emit('select', selectedOption, id);
      },
      onRemoveHandler(removedOption, id) {
        this.$emit('remove', removedOption, id);
      },
      async searchChange(searchQuery, id) {
        this.$emit('search-change', searchQuery, id);

        if ( this.asyncFind ) {
          const asyncFindResult = this.asyncFind(searchQuery);

          if ( Array.isArray(asyncFindResult) ) {
            this.asyncOptions = asyncFindResult;
          }

          if ( typeof asyncFindResult.then === 'function' ) {
            this.isLoading = true;
            const response = await asyncFindResult;

            this.asyncOptions =
              Array.isArray(response.data) ?
                response.data :
                Array.isArray(response) ?
                  response :
                  [];

            this.isLoading = false;
          }
        }
      }
    },
    components: { Multiselect }
  };
</script>
